import { GetDeviceDetail_device } from '../../device-details/queries/generated/getDeviceDetail';
import { DeviceRegisterListItem } from '../models/device-register-results.model';
import { GetDevices_devicesConnection_items } from '../queries/generated/GetDevices';

export const deviceRegisterColumns: string[] = ['deviceType', 'name', 'active'];

export function convertDeviceRegisterListItem(
   getDeviceItem: GetDevices_devicesConnection_items
): DeviceRegisterListItem {
   return {
      accountName: getDeviceItem?.account?.name || null,
      ztStatus: getDeviceItem.ztStatus,
      createDate: getDeviceItem.createDate,
      createUserName: getDeviceItem.createUser?.name || null,
      deviceId: getDeviceItem.deviceId,
      deviceModel: getDeviceItem.deviceTypeId,
      macAddress: getDeviceItem.macAddress,
      phoneExtension: getDeviceItem.phone?.extension
         ? {
              extensionId: getDeviceItem.phone.extension.extensionId,
              name: getDeviceItem.phone.extension.name,
              number: getDeviceItem.phone.extension.number,
           }
         : null,
      defaultPhoneNumber: getDeviceItem.phone?.extensionPhone?.defaultPhoneNumber?.phoneNumber || null,
      sipUsers: getDeviceItem.phone?.sipUsersConnection?.items || null,
      serialNumber: getDeviceItem.serialNumber,
      lastFirmware: getDeviceItem.serialNumber,
      lastProvisioned: getDeviceItem.lastProvisionedDate,
      notes: getDeviceItem.notes,
      updateDate: getDeviceItem.updateDate,
      updateUserName: getDeviceItem.updateUser?.name || null,
      isConnected: getIsConnectedFromDevice(getDeviceItem),
      lastConnected: getLastConnectedFromDevice(getDeviceItem),
      isHacked: getIsHackedFromDevice(getDeviceItem),
      isFraud: getIsFraudFromDevice(getDeviceItem),
      hackedAndFraudSipUserIds: getHackedAndFraudSipUserIdsFromDevice(getDeviceItem),
      hackedOrFraudExtension: getHackedOrFraudExtensionNamesFromDevice(getDeviceItem),
      basestationHandsets: getDeviceItem.baseStationHandsetsConnection.items,
   };
}

export function getHackedOrFraudExtensionNamesFromDevice(
   getDeviceItem: GetDevices_devicesConnection_items | GetDeviceDetail_device
): string | null {
   if (getDeviceItem.phone?.sipUsersConnection.items.length) {
      const hackedOrFraudExtensionNames = getDeviceItem.phone.sipUsersConnection.items
         .map((sipUser) => {
            if (sipUser.isHacked || sipUser.isFraud) {
               return sipUser.phone.extension ? sipUser.phone.extension.name : null;
            }
            return null;
         })
         .filter((name) => name !== null);
      return hackedOrFraudExtensionNames.length > 0 ? hackedOrFraudExtensionNames.join(', ') : null;
   }
   return null;
}

export function getIsHackedFromDevice(
   getDeviceItem: GetDevices_devicesConnection_items | GetDeviceDetail_device
): boolean {
   if (getDeviceItem.phone?.sipUsersConnection.items.length) {
      return (
         getDeviceItem.phone.sipUsersConnection.items.filter((x) => {
            return x.isHacked === true;
         }).length > 0
      );
   }
   return false;
}

export function getIsFraudFromDevice(
   getDeviceItem: GetDevices_devicesConnection_items | GetDeviceDetail_device
): boolean {
   if (getDeviceItem.phone?.sipUsersConnection.items.length) {
      return (
         getDeviceItem.phone.sipUsersConnection.items.filter((x) => {
            return x.isFraud === true;
         }).length > 0
      );
   }
   return false;
}

export function getHackedAndFraudSipUserIdsFromDevice(
   getDeviceItem: GetDevices_devicesConnection_items | GetDeviceDetail_device
): number[] {
   if (getDeviceItem.phone?.sipUsersConnection.items.length) {
      return getDeviceItem?.phone?.sipUsersConnection.items
         .filter((x) => x.isHacked || x.isFraud)
         .map((x) => x.sipUserId) as number[];
   }
   return [];
}

export function getIsConnectedFromDevice(
   getDeviceItem: GetDevices_devicesConnection_items | GetDeviceDetail_device
): boolean {
   if (getDeviceItem.phone?.sipUsersConnection.items && getDeviceItem.phone?.sipUsersConnection.items.length > 0) {
      return (
         getDeviceItem.phone.sipUsersConnection.items.filter((x) => {
            return x.isConnected === true;
         }).length > 0
      );
   } else if (
      getDeviceItem.baseStationHandsetsConnection.items &&
      getDeviceItem.baseStationHandsetsConnection.items.length > 0
   ) {
      return getDeviceItem.baseStationHandsetsConnection.items.some((item) => {
         return (
            item.phone.sipUsersConnection.items &&
            item.phone.sipUsersConnection.items.length > 0 &&
            item.phone.sipUsersConnection.items.some((sipUser) => {
               return sipUser.isConnected === true;
            })
         );
      });
   }
   return false;
}

function getLastConnectedFromDevice(getDeviceItem: GetDevices_devicesConnection_items): Date | null {
   let mostRecentLastConnected: Date | null = null;

   // Check `baseStationHandsetsConnection` for the most recent `lastConnected`
   if (getDeviceItem.baseStationHandsetsConnection?.items) {
      for (const handset of getDeviceItem.baseStationHandsetsConnection.items) {
         if (handset.phone?.sipUsersConnection?.items) {
            for (const sipUser of handset.phone.sipUsersConnection.items) {
               if (sipUser.lastConnected) {
                  const lastConnectedDate = new Date(sipUser.lastConnected);
                  if (!mostRecentLastConnected || lastConnectedDate > mostRecentLastConnected) {
                     mostRecentLastConnected = lastConnectedDate;
                  }
               }
            }
         }
      }
   }

   // Check `phone.sipUsersConnection` for the most recent `lastConnected`
   if (getDeviceItem.phone?.sipUsersConnection?.items) {
      for (const sipUser of getDeviceItem.phone.sipUsersConnection.items) {
         if (sipUser.lastConnected) {
            const lastConnectedDate = new Date(sipUser.lastConnected);
            if (!mostRecentLastConnected || lastConnectedDate > mostRecentLastConnected) {
               mostRecentLastConnected = lastConnectedDate;
            }
         }
      }
   }

   return mostRecentLastConnected;
}
